<template>
  <v-card
    id="shifts-summary"
    v-if="currentUserNextShift || currentUserLastShift"
  >
    <v-container class="pa-3" fluid>
      <v-layout
        class="mb-3 text-xs-center grey lighten-2"
        row
        align-center
        justify-center
        align-content-center
      >
        <v-flex class="mr-1" shrink>
          <v-icon>work</v-icon>
        </v-flex>
        <v-flex shrink>
          <h1 class="subtle all-caps">Shifts</h1>
        </v-flex>
      </v-layout>

      <v-layout
        v-if="currentUserNextShift"
        row
        wrap
        align-center
      >
        <v-flex xs12 sm3 class="text-xs-center">
          <h2 class="all-caps green--text">Next Shift</h2>
        </v-flex>
        <v-flex xs12 sm5 class="text-xs-center">
          <div>
            <span>
              {{ currentUserNextShift.startDatetime | moment("M/D") }} |
              {{ currentUserNextShift.startDatetime | moment("h:mma") }} -
              {{ currentUserNextShift.endDatetime | moment("h:mma") }}
            </span>
          </div>
          <div>
            <router-link
              :to="{
                name: 'shiftDetail',
                params: { shiftId: currentUserNextShift.id },
              }"
            >
              <span class="font-weight-bold">
                {{ currentUserNextShift.shiftRole }} |
                {{ currentUserNextShift.location }}
              </span>
            </router-link>
          </div>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-center">
          <v-btn
            v-if="
              isWithinClockableTime(currentUserNextShift) &&
                !currentUserCurrentShift
            "
            :to="{ name: 'timeclockShiftConfirm' }"
            color="info"
          >
            <v-icon>timer</v-icon>
            Timeclock
          </v-btn>
        </v-flex>
      </v-layout>

      <v-divider
        v-if="currentUserNextShift && currentUserLastShift"
        class="my-3"
        style="border-top-width: 3px;"
      ></v-divider>

      <v-layout
        v-if="currentUserLastShift"
        row
        wrap
        align-center
      >
        <v-flex xs12 sm3 class="text-xs-center">
          <h2 class="all-caps subtle">Last Shift</h2>
          <div>
            <div v-for="(punch, idx) in sortedPunches" :key="idx">
              <ul class="info-listing">
                <li v-if="punch.start">
                  <span class="subtle">Time In:</span>
                  {{ punch.punchTime | moment("h:mm a") }}
                </li>
                <li v-else class="mb-2">
                  <span class="subtle">Time Out:</span>
                  {{ punch.punchTime | moment("h:mm a") }}
                </li>
              </ul>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm5 class="text-xs-center">
          <div>
            <span>
              {{ currentUserLastShift.startDatetime | moment("M/D") }} |
              {{ currentUserLastShift.startDatetime | moment("h:mma") }} -
              {{ currentUserLastShift.endDatetime | moment("h:mma") }}
            </span>
          </div>
          <div>
            <router-link
              :to="{
                name: 'shiftDetail',
                params: { shiftId: currentUserLastShift.id },
              }"
            >
              <span class="font-weight-bold">
                {{ currentUserLastShift.shiftRole }} |
                {{ currentUserLastShift.location }}
              </span>
            </router-link>
          </div>
          <div class="subheading font-weight-bold">
            <span class="all-caps subtle">Total:</span>
            <span>{{ currentUserLastShift.totalHours }} Hours</span>
          </div>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-center">
          <v-layout column align-content-space-between>
            <MessagePopup
              color="primary"
              :recipientId="managers"
              :senderId="user.id"
              buttonText="Adjust Request"
            />
            <div v-if="currentUserCurrentShift">
              <ShiftPopup
                color="primary"
                :shiftId="currentUserCurrentShift.id"
                :shift="currentUserCurrentShift"
                :user="user"
                buttonText="Notes"
              />
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MessagePopup from "@/components/base/message-popup.vue";
import ShiftPopup from "@/components/base/shift-popup.vue";

export default {
  created() {
    this.fetchData();
  },
  components: {
    MessagePopup,
    ShiftPopup,
  },
  watch: {
    $route: "fetchData",
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    ...mapState("shifts", [
      "currentUserCurrentShift",
      "currentUserNextShift",
      "currentUserLastShift",
    ]),
    ...mapState("timeclock", ["punches"]),
    ...mapGetters("timeclock", ["sortedPunches"]),
  },
  data: function() {
    return {
      managers: 312, // Lanie (staff@helpthevet.com) — default recipient per VSS request
    };
  },
  methods: {
    isWithinClockableTime(shift) {
      return this.$moment(shift.startDatetime).isBefore(
        this.$moment(new Date()).add(1, "h")
      );
    },
    fetchData() {
      this.$store.dispatch("shifts/getCurrentUserUpcoming").finally(() => {});
      this.$store.dispatch("timeclock/getCurrentUserLastPunches");
    },
  },
};
</script>

<style scoped>
#shifts-summary {
}
</style>
